import util from '../util'
import arrays from '../arrays'

let controller = 'RegistroBoleto'

export default Object.assign({}, util.GetCrud(controller, ['get', 'post']), {
  GetAll: function (model, search, options) {
    let dto = {
      parameters: []
    }

    if (options && options.data) dto.data = options.data

    if (!(model.codBarras && model.codBarras !== '')) {
      dto.parameters.push({ name: 'documentoPagador', value: model.documentoPagador })
      dto.parameters.push({ name: 'nomePagador', value: model.nomePagador })
      dto.parameters.push({ name: 'dtRegistro', value: model.dtRegistro })
      dto.parameters.push({ name: 'dtVencimento', value: model.dtVencimento })
      dto.parameters.push({ name: 'seuNumero', value: model.seuNumero })
      dto.parameters.push({ name: 'nossoNumero', value: model.nossoNumero })

      if (model.codigoCedente && model.codigoCedenteCarteira) { dto.parameters.push({ name: 'codigoCedenteCarteira', value: model.codigoCedenteCarteira.value }) }

      if (model.especie) { dto.parameters.push({ name: 'especie', value: model.especie.value }) }

      if (model.modalidade) { dto.parameters.push({ name: 'modalidade', value: model.modalidade.value }) }

      if (model.situacaoBoleto) { dto.parameters.push({ name: 'situacaoBoleto', value: model.situacaoBoleto.value }) }

      if (model.dtVencimentoFinal) { dto.parameters.push({ name: 'dtVencimentoFinal', value: model.dtVencimentoFinal }) }
      if (model.dtProtestoInicio) { dto.parameters.push({ name: 'dtProtestoInicio', value: model.dtProtestoInicio }) }
      if (model.dtProtestoFinal) { dto.parameters.push({ name: 'dtProtestoFinal', value: model.dtProtestoFinal }) }
      if (model.consultaProtesto) { dto.parameters.push({ name: 'consultaProtesto', value: model.consultaProtesto }) }
      if (model.dtPagamentoInicio) { dto.parameters.push({ name: 'dtPagamentoInicio', value: model.dtPagamentoInicio }) }
      if (model.dtPagamentoFim) { dto.parameters.push({ name: 'dtPagamentoFim', value: model.dtPagamentoFim }) }
    }

    dto.parameters.push({ name: 'codBarras', value: model.codBarras })

    dto.parameters.push({ name: 'filter', value: search })

    return util.Axios.GetAll(controller, dto)
  },
  ImpressaoBoleto: function (id) {
    return util.Axios.Get(controller + '/ImpressaoBoleto', id)
  },
  RelatorioBoletoRegistrado: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/RelatorioBoletoRegistrado', dto)
  },
  GerarExcelRelatorioBoletoRegistrado: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/GerarExcelRelatorioBoletoRegistrado', dto)
  },
  ConsultarRegistro: function (dto) {
    return util.Axios.Post(controller + '/ConsultarRegistro', dto)
  },
  BuscarQRCode: function (id) {
    return util.Axios.Get(controller + '/BuscarQRCode', id)
  }
})
